var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerWhiteClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 16H16C16.7333 16 17.3333 15.4 17.3333 14.6667C17.3333 13.9333 16.7333 13.3333 16 13.3333H1.33333C0.6 13.3333 0 13.9333 0 14.6667C0 15.4 0.6 16 1.33333 16ZM1.33333 9.33333H12C12.7333 9.33333 13.3333 8.73333 13.3333 8C13.3333 7.26667 12.7333 6.66667 12 6.66667H1.33333C0.6 6.66667 0 7.26667 0 8C0 8.73333 0.6 9.33333 1.33333 9.33333ZM0 1.33333C0 2.06667 0.6 2.66667 1.33333 2.66667H16C16.7333 2.66667 17.3333 2.06667 17.3333 1.33333C17.3333 0.6 16.7333 0 16 0H1.33333C0.6 0 0 0.6 0 1.33333ZM23.0667 11.84L19.2267 8L23.0667 4.16C23.5867 3.64 23.5867 2.8 23.0667 2.28C22.5467 1.76 21.7067 1.76 21.1867 2.28L16.4 7.06667C15.88 7.58667 15.88 8.42667 16.4 8.94667L21.1867 13.7333C21.7067 14.2533 22.5467 14.2533 23.0667 13.7333C23.5733 13.2133 23.5867 12.36 23.0667 11.84Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerWhiteClose);
export default __webpack_public_path__ + "static/media/burger_white_close.04112d22bee7cae1cacc16406f376f48.svg";
export { ForwardRef as ReactComponent };